import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  IKFBreadCrumItem,
  KFBreadCrumbV2,
} from 'shared/modules/breadcrumbsV2/breadcrumbsV2';

interface IHiringBreadCrumb {
  id?: string;
  breadCrumbItems: IKFBreadCrumItem[];
}

const HiringBreadCrumb: React.FC<IHiringBreadCrumb> = ({
  id,
  breadCrumbItems,
}: IHiringBreadCrumb) => {
  const location = useLocation();

  const handleOnClickBreadcrumb = (
    path: string | undefined,
    sameTab: boolean | undefined,
    navigate: any
  ) => {
    navigate(path, { state: location.state });
  };

  return (
    <KFBreadCrumbV2
      id={id || 'hiring-breadcrumb'}
      breadCrumbItems={breadCrumbItems || []}
      showPrevButton={false}
      onClickTitle={handleOnClickBreadcrumb}
      sx={{ ml: 1 }}
    />
  );
};

export default HiringBreadCrumb;
